module.exports = __webpack_public_path__ + "static/media/Jumpluff_gaussian2.377cc055.png";